import schild from "./Schild.svg";
import ascore from "./ascore.jpg";
import bankSepa from "./bank-sepa.png";
import logo from "./logo.svg";
import tuev from "./TR-Testmark_DE.png"
import kampagne1Hund from "./kampagne_1_hund.png";
import kampagne2Hundehalsband from "./kampagne_2_hundehalsband.png";
import dackel from "./dackel.png";
import dogoramaLogo from "./dogorama_logo.png";
import bissig from "./bissig.png";
import collageDogorama from "./collage_thv.png";

const Images = {
    schild,
    ascore,
    bankSepa,
    logo,
    tuev,
    kampagne1Hund,
    kampagne2Hundehalsband,
    dackel,
    dogoramaLogo,
    bissig,
    collageDogorama
}

export default Images;